import React from 'react';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal, TextAreaField, Label } from 'components';
import { Button } from 'antd';
import {
  outcomes,
} from 'utils';
// import { radioOptions, radioOptionsBeneficiaryObjection } from './utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';

const RejectModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  outcome,
  comment,
  setComment,
  setVisibleReject,
}) => {

  const renderContent = () => {
        return (
          <div>
            <div className="content-title color-red font-size-24 mb-2">
              Απόρριψη Αίτησης
            </div>
            <div>
              Πρόκειται να απορρίψετε την αίτηση. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά
              επιλέξτε Ακύρωση.
            </div>
          <div className="mt-2">
            <TextAreaField
                id={'rejectComment'}
                label={'Μήνυμα Απόρριψης'}
                placeholder={'Προσθήκη Σχολίου'}
                asterisk={true}
                name={'comment'}
                value={comment}
                maxLength={500}
                onChange={event =>
                    setComment(event.target.value)
                }
            />
            </div>
            <div className="register-buttons mt-2">
                <Button
                    className="return-button mt-3"
                    type="secondary"
                    disabled={false}
                    onClick={() => setVisibleReject(false)}
                >
                    Ακύρωση
                </Button>
                <Button
                    type="primary"
                    className="submit-login mt-3"
                    disabled={isEmpty(comment?.trim())}
                    onClick={submit}
                    id="inputEnter"
                >
                    Απόρριψη
                </Button>
            </div>
        </div>
    );
}

  const submit = () => {
    setIsVisible(false);
    handleSubmit(false);
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        submitDisabled={false}
        Icon={WarningRed}
        outcome={outcome}
        className={'invalid-modal no-border'}
        footer={null}
        closable={false}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
    </>
  );
};

export default RejectModal;
